import {isPlainObject, objValueAsString} from "@utils/object";
import {addUniqueCssClasses} from "@functions/css";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import React from "react";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import PolicyHolderAccidentForm from "./parts/policy-holder-accident-form";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";

export const CommonPolicyHolderClaimsForm = ({
   
   containerAttrs = {},
   sectionHeading = 'Claims',
   showSectionHeading = true,
   data,
   onChange,
   
   addPolicyHolderAccident,
   handlePolicyHolderAccidentPropChange,
   removePolicyHolderAccident
   
}) => {
   
   containerAttrs = isPlainObject(containerAttrs) ? containerAttrs : {};
   
   containerAttrs.className = addUniqueCssClasses(
      objValueAsString(containerAttrs, 'className'),
      'claims-form-container'
   );
   
   return (
      <div {...containerAttrs}>
         
         {showSectionHeading && (
            <SectionHeading
               text={sectionHeading}
            
            />
         )}
         
         {/* Any motor accidents or claims in the last 5 years? */}
         
         <ScrollableButtonGroupBlock
            containerCssClass="col-12 py-3 "
            labelText="Any motor accidents or claims in the last 5 years?"
            required={true}
            controlName="hasAccidentClaimsInLast5Years"
            options={YES_NO_CHOICE_OPTIONS}
            selectedValues={data.hasAccidentClaimsInLast5Years}
            onChange={onChange}
         />
         
         {data.hasAccidentClaimsInLast5Years === 'Yes' && data.motorAccidentsList.length !== 0 && (
            
            <div className="hidden-box p-0 d-flex flex-column gap-2">
               
               <div className="col-12 d-flex flex-column gap-2">
                  
                  {data.motorAccidentsList?.map((accident, accidentIndex) => (
                     <PolicyHolderAccidentForm
                        key={accidentIndex}
                        accidentIndex={accidentIndex}
                        accident={accident}
                        motorAccidentsListPropName={`motorAccidentsList`}
                        handlePolicyHolderAccidentPropChange={handlePolicyHolderAccidentPropChange}
                        addPolicyHolderAccident={addPolicyHolderAccident}
                        removePolicyHolderAccident={removePolicyHolderAccident}
                     />
                  ))}
               
               </div>
            
            
            </div>
         
         )}
         
         {data.hasAccidentClaimsInLast5Years === 'Yes'
            && data.motorAccidentsList.length === 0
            && (
               
               <div className="col-12 py-3 text-center text-danger scrollable" data-block="motorAccidentsList">
                  No accident record submitted yet!
               </div>
            
            )}
         
         {data.hasAccidentClaimsInLast5Years === 'Yes' && (
            
            <div className="col-12 py-3 text-center">
               <AddItemButtonComponent
                  text="Add Incident"
                  onClick={(e) => addPolicyHolderAccident()}
               />
            </div>
            
         )}
         
      </div>
   );
};